module.exports = __webpack_public_path__ + "img/it-rollupbanner.381680a2.jpg";